module.exports = __webpack_public_path__ + "static/media/gold.5494cb62.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/gold.png
// module id = 1943
// module chunks = 0